var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex gap-2 border rounded-lg border-gray-200 py-2 px-3 text-xs cursor-pointer font-mulish"},_vm._l((_vm.tabs),function(tab,i){return _c('button',{key:i,class:`${
      tab.slug == _vm.activeBtn ? 'active' : 'text-dkgray'
    } py-1.5 px-4 rounded font-semibold max-w-max text-sm`,on:{"click":function($event){return _vm.tabClick(tab)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }